import { environment } from '../../environments/environment';

export const endpoints = {
  auth: {
    login: environment.apiUrl + '/auth/login',
    reiniciar: environment.apiUrl + '/auth/password/restore',
    cambiar: environment.apiUrl + '/auth/password/reset',
    me: environment.apiUrl + '/auth/me',
    logout: environment.apiUrl + '/auth/logout',
    refresh: environment.apiUrl + '/auth/refresh'
  },
  registro: {
    catalogos: environment.apiUrl + '/catalogos/registro',
    registrar: environment.apiUrl + '/registro/registrar',
    reenviar: environment.apiUrl + '/registro/reenviar',
    confirmar: environment.apiUrl + '/registro/confirmar',
    generarFormulario: environment.reportesUrl + '/formulario-pdf',
    generarDeclaracionComposicionQuimica: environment.reportesUrl + '/declaracionComposicionQuimica-pdf',
    generarFormularioPostProductos: environment.reportesUrl + '/formulario-pdf-post',
    validatePel: environment.apiUrl + '/registro/portal',
    confirmarPel: environment.apiUrl + '/registro/portal/confirmar',
    //info_user: environment.apiUrl + '/registro/check',
    info_user: environment.catalogosUrl + '/rnpn/dui',
  },
  core: {
    obtenerSolicitudes: environment.coreBpmUrl + '/instancia/all/usuario',
    obtenerFormulario: environment.coreBpmUrl + '/procesos/form',
    obtenerInstancia: environment.coreBpmUrl + '/instancia',
    guardarInstancia: environment.coreBpmUrl + '/instancia',
    enviarSolicitud: environment.coreBpmUrl + '/instancia/store/envia',
    guardarEstadoInstancia: environment.coreBpmUrl + '/instancia/guardarEstado',
    guardarDesistimientoInstancia: environment.coreBpmUrl + '/instancia/guardarDesistimiento',
    prorrogaInstancia: environment.coreBpmUrl + '/instancia/prorroga',
    eliminarInstancia: environment.coreBpmUrl + '/instancia/eliminar',
  },
  catalogos: {
    obtenerTiposEstablecimientos: environment.catalogosUrl + '/VWMenuInscripcionEstablecimientos?filter[tipo_registro]=PRE',
    obtenerTiposEstablecimientosPR: environment.catalogosUrl + '/VWMenuInscripcionEstablecimientos?filter[tipo_registro]=POS',
    obtenerTiposEstablecimientosArea: environment.catalogosUrl + '/VWMenuInscripcionEstablecimientos',
    obtenerTiposPoderes: environment.catalogosUrl + '/VWMenuInscripcionPoderes?filter[tipo_registro]=PRE',
    obtenerTiposPoderesPR: environment.catalogosUrl + '/VWMenuInscripcionPoderes?filter[tipo_registro]=POS',
    obtenerTiposContratos: environment.catalogosUrl + '/VWMenuInscripcionContratos?filter[tipo_registro]=PRE',
    obtenerTiposContratosPR: environment.catalogosUrl + '/VWMenuInscripcionContratos?filter[tipo_registro]=POS',
    obtenerTiposFarmaceuticos: environment.catalogosUrl + '/VWMenuProdFarmaceutico?filter[tipo_registro]=PRE',
    obtenerTiposFarmaceuticosPR: environment.catalogosUrl + '/VWMenuProdFarmaceutico?filter[tipo_registro]=POS',
    obtenerTiposFarmaceuticosGeneral: environment.catalogosUrl + '/VWMenuProdFarmaceutico',
    obtenerTiposDispositivos: environment.catalogosUrl + '/VWMenuDispositivos?filter[tipo_registro]=PRE',
    obtenerTiposDispositivosPR: environment.catalogosUrl + '/VWMenuDispositivos?filter[tipo_registro]=POS',
    obtenerTiposCosmeticosPR: environment.catalogosUrl + '/VWMenuProdCosHig?filter[tipo_registro]=POSC',
    obtenerTiposHigienicosPR: environment.catalogosUrl + '/VWMenuProdCosHig?filter[tipo_registro]=POSH',
    obtenerTiposDispositivosGeneral: environment.catalogosUrl + '/VWMenuDispositivos',
    obtenerTiposCosHigGeneral: environment.catalogosUrl + '/VWMenuProdCosHig',
    obtenerTiposQuimicosGeneral: environment.catalogosUrl + '/VWMenuQuimicos',
    obtenerTiposQuimicos: environment.catalogosUrl + '/VWMenuQuimicos?filter[tipo_registro]=PRE',
    obtenerTiposQuimicosPR: environment.catalogosUrl + '/VWMenuQuimicos?filter[tipo_registro]=POS',
    obtenerTiposCosmeticos: environment.catalogosUrl + '/VWMenuProdCosHig?filter[tipo_registro]=PRE',
    obtenerTiposPublicidad: environment.catalogosUrl + '/VWMenuPublicidad?filter[tipo_registro]=PRE',
    obtenerTiposAnalisisLaboratorios: environment.catalogosUrl + '/VWMenuInscripcionAnalisisLaboratorios?filter[tipo_registro]=PRE',
    obtenerTramitesPendientes: environment.catalogosUrl + '/tramitesPendientes',
    historialSolicitudes: environment.catalogosUrl + '/VWHistorialSolicitud?filter[ver_externo]=1&filter[id_instancia_proceso]=',
    obtenerTiposLotesVacunas: environment.catalogosUrl + '/VWMenuLotesVacunas?filter[tipo_registro]=PRE',
    obtenerTiposLotesVacunasPR: environment.catalogosUrl + '/VWMenuLotesVacunas?filter[tipo_registro]=POS',
    ObtenerDatosMercado: environment.catalogosUrl + '/VWMenuDatosMercados?filter[tipo_registro]=PRE',
    ObtenerDatosMercadoPR: environment.catalogosUrl + '/VWMenuDatosMercados?filter[tipo_registro]=POS',
    ObtenerTiposProcesosEstupefacientesGeneral: environment.catalogosUrl + '/VWMenuEstupefacientes',
    ObtenerTiposProcesosEstupefacientes: environment.catalogosUrl + '/VWMenuEstupefacientes?filter[tipo_registro]=PRE',
    ObtenerTiposProcesosEstupefacientesPR: environment.catalogosUrl + '/VWMenuEstupefacientes?filter[tipo_registro]=POS',
    getFechaHabil: environment.catalogosUrl + '/fechahabil',
    searchTramites: environment.catalogosUrl + '/tramitesSearch',
    alimentosYBebidas: environment.catalogosUrl + '/VWMenuAlimentosYBebidas',
    entidades: environment.catalogosUrl + '/tiposEntidades',
    persona: environment.catalogosUrl + '/rnpn/dui',
    tipoComprobante: environment.catalogosUrl + '/entidadesTiposComprobantes',
    municipios: environment.catalogosUrl + '/municipios',
    departamentos: environment.catalogosUrl + '/departamentos',
    entidadesLista: environment.catalogosUrl + '/entidadesLista',
    saveEntidadNatural: environment.catalogosUrl + '/entidad/natural',
    saveEntidadJuridica: environment.catalogosUrl + '/entidad/juridica',
    saveEntidadExtranjera: environment.catalogosUrl + '/entidad/extranjero',
    saveEntidadIntitucional: environment.catalogosUrl + '/entidad/instituciones',
    tiposVeterinarios: environment.catalogosUrl + '/VWMenuVeterinarios',
  },
  gestordocumental: {
    subirArchivo: environment.gestorDocumentalUrl + '/upload/temporary/new',
    descargarArchivo: environment.gestorDocumentalUrl + '/download/',
  }, 
  colecturia: {
    searchMandamiento: environment.colecturiaUrl + '/mandamiento/search',
    generarTokenSerfinsa: environment.colecturiaUrl + '/serfinsa/token/pay',
  },
  reportes: {
    comprobanteSerfinsa: environment.reportesUrl + '/serfinsa/comprobante',
  }
};
